import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../../utils/validate-payload.js';
import { searchParametersDefinition } from './search-parameters-schema.js';
export const restoreSearchParameters = createAction('commerce/searchParameters/restore', (payload) => validatePayload(payload, searchParametersDefinition));
